module.exports = __webpack_public_path__ + "static/14.3_the_birth_of_christianity-68178ae891b8a0b09a8bc26b475504f0.pdf";